import React from 'react';
import { Link } from 'react-router-dom';
import './Alec.css';
import PageHero from './PageHero';

const Alec = () => {
  const skillsData = [
    {
      name: "Videography",
      description: "Filming, editing, and cinematic storytelling",
      icon: "/davinci.png",
      rating: 92
    },
    {
      name: "Photography",
      description: "Capturing and retouching striking photos",
      icon: "/pixlr.svg",
      rating: 90
    },
    {
      name: "Color Grading",
      description: "Cinematic color and finishing in DaVinci Resolve",
      icon: "/davinci.png",
      rating: 86
    },
  ];

  return (
    <>
      <PageHero
        eyebrow="Crew / Alec Wyrick"
        title="Alec Wyrick"
        lede="Photography and videography. Telling stories through the lens — planning the shot, lighting the scene, then finishing it in the grade."
        meta={['Photo · Video', 'Lighting · Colour', 'DaVinci Resolve']}
      >
        <Link
          to={`/contact?reason=quote&topic=${encodeURIComponent('Photography or videography')}`}
          className="btn btn--primary"
        >
          Book a shoot <span className="btn-arrow">→</span>
        </Link>
        <Link to="/crew" className="btn btn--ghost">
          Back to crew
        </Link>
      </PageHero>

      <main className="alec-main-content" id="main">
        <section className="section alec-about-section">
          <div className="container container--narrow">
            <p className="eyebrow">About</p>
            <div className="alec-about-text">
              <p className="reveal reveal-up">
                Alec is a photographer and videographer who brings a sharp creative eye to
                everything our team ships. From product and event shoots to full video
                productions, he captures the footage that makes a brand feel real.
              </p>
              <p className="reveal reveal-up" style={{ '--reveal-delay': '0.08s' }}>
                His work runs the full pipeline — planning the shot, lighting the scene,
                capturing photo and video, then editing and colour grading in DaVinci
                Resolve. The result is polished content built for websites, social, and
                campaigns.
              </p>
            </div>
          </div>
        </section>

        <section className="section section--alt alec-skills-section">
          <div className="container">
            <div className="section-head">
              <p className="eyebrow">Toolkit</p>
              <h2 className="section-title reveal reveal-up">Skills &amp; expertise.</h2>
              <p className="section-lede reveal reveal-up" style={{ '--reveal-delay': '0.08s' }}>
                Proficiency measured against real shoots, not coursework.
              </p>
            </div>

            <ul className="alec-skills-grid" data-stagger="0.06">
              {skillsData.map((skill) => (
                <li key={skill.name} className="alec-skill-card reveal reveal-up">
                  <div className="alec-skill-header">
                    <img src={skill.icon} alt="" className="alec-skill-icon" />
                    <div className="alec-skill-info">
                      <h3 className="alec-skill-name">{skill.name}</h3>
                      <p className="alec-skill-description">{skill.description}</p>
                    </div>
                    <span className="alec-rating-text">{skill.rating}</span>
                  </div>
                  <div className="alec-rating-bar">
                    <span className="alec-rating-fill" style={{ width: `${skill.rating}%` }} />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="section alec-projects-section">
          <div className="container">
            <div className="section-head">
              <p className="eyebrow">Portfolio</p>
              <h2 className="section-title reveal reveal-up">Photo &amp; video work.</h2>
            </div>

            <div className="alec-project-card reveal reveal-up">
              <div className="alec-video-container">
                <span className="alec-reel-placeholder">
                  <span className="alec-reel-mark" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <rect
                        x="2.5"
                        y="6"
                        width="14"
                        height="12"
                        rx="2"
                        stroke="currentColor"
                        strokeWidth="1.4"
                      />
                      <path
                        d="M16.5 11l5-2.6v7.2l-5-2.6z"
                        stroke="currentColor"
                        strokeWidth="1.4"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  Portfolio reel coming soon
                </span>
              </div>

              <div className="alec-project-info">
                <div className="alec-project-timestamp">In progress</div>
                <h3>Photography &amp; video portfolio</h3>
                <p>
                  A growing collection of Alec&rsquo;s photo and video work — product
                  shoots, event coverage, and brand videos produced for ShawnyMedia
                  clients.
                </p>

                <h4>Featured work</h4>
                <ul>
                  <li>Product &amp; brand photography</li>
                  <li>Event and highlight videography</li>
                  <li>Promotional and social video edits</li>
                  <li>Colour grading and post-production</li>
                </ul>

                <h4>Tools</h4>
                <div className="alec-tech-stack">
                  <img src="/davinci.png" alt="DaVinci Resolve" title="DaVinci Resolve" />
                  <img src="/pixlr.svg" alt="Pixlr" title="Pixlr" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section section--alt alec-contact-section">
          <div className="container">
            <div className="section-head">
              <p className="eyebrow">Say hello</p>
              <h2 className="section-title reveal reveal-up">
                Need photos or video for your brand?
              </h2>
            </div>

            <div className="alec-contact-grid" data-stagger="0.07">
              <div className="alec-contact-card reveal reveal-up">
                <h3>Photography</h3>
                <p>Product, event, or brand photography for your business.</p>
                <Link
                  to={`/contact?reason=quote&topic=${encodeURIComponent('Photography')}`}
                  className="btn btn--ghost"
                >
                  Get a quote <span className="btn-arrow">→</span>
                </Link>
              </div>

              <div className="alec-contact-card reveal reveal-up">
                <h3>Videography</h3>
                <p>Promotional videos, event coverage, or social content.</p>
                <Link
                  to={`/contact?reason=quote&topic=${encodeURIComponent('Videography / video production')}`}
                  className="btn btn--ghost"
                >
                  Get a quote <span className="btn-arrow">→</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Alec;
